export const getRandomId = () => self.crypto.randomUUID();

export const getIssueTypeIdFromTypeId = (typeId: string) => {
    return typeId && typeId.split('-')[0];
};

export const downloadJsonFile = (content: string, fileName: string) =>
    downloadFile(new Blob([content], { type: 'application/json' }), fileName, 'json');

export const downloadCsvFile = (content: string, fileName: string) =>
    downloadFile(new Blob([content], { type: 'text/csv' }), fileName, 'csv');

const downloadFile = (file: Blob, fileName: string, extension: 'json' | 'csv') => {
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(file);
    downloadLink.download = `${fileName}.${extension}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

export const getValueFromPath = (obj: any, path: string[]) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return path && obj && path.reduce((o, i) =>  o ? o[i] : undefined, obj);
};